import cx from 'clsx';
import { fieldSubscription, guessDecimal, useField, useNumberParser } from '@ff-it/form';
import { Box } from '@ff-it/ui';
import { amountInput } from './style.css';
import { useCallback } from 'react';

function format(value: any): any {
  return value === null || value === undefined ? '' : value.toString();
}

// this is here just because DecimalField is bound to FormGroup
export function AmountInput({ name }: { name: string }): React.ReactElement {
  const parse = useNumberParser(2);

  const { input, meta } = useField<string, any>(name, {
    parse,
    format,
    subscription: fieldSubscription,
    allowNull: true,
    // validate: positive, depends on the source sign
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: onChange is stable
  const onPaste = useCallback((event: React.ClipboardEvent) => {
    const text = event.clipboardData.getData('text');
    if (text) {
      input.onChange(guessDecimal(text));
    }

    event.preventDefault();
  }, []);

  return (
    <Box
      as="input"
      className={cx(amountInput, meta.invalid && meta.touched ? 'is-invalid' : undefined)}
      onPaste={onPaste}
      type="text"
      {...input}
      autoComplete="off"
    />
  );
}
